
import moment from "moment";
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  onActivated,
  watch,
  toRefs,
} from "vue";
import { queryApplyInfo, approveApply, wechatLogin } from "@/apis/comm/api";
import { useRoute, useRouter } from "vue-router";
import { showSuccessToast, showToast, showLoadingToast } from "vant";
import router from "@/router";
import _ from "lodash";
import axios from "@/apis/config";

export default defineComponent({
  name: "applyfor",
  setup() {
    const route = useRoute();
    onMounted(async () => {
      info.shdate = moment().format("YYYY-MM-DD");
      const query = route.query;
      if (query && query.id) {
        info.id = query.id;

        info.getApplyInfo();
      }
    });
    const formRef = ref(null);
    const info = reactive({
      id: "" as any,
      token: "" as any,
      sdWorkHandleId: "" as any,
      view: false,
      form: {},
      shr: "",
      shdate: "",
      idea: undefined as any,
      applyInfo: {} as any,
      dataList: [],
      remark: "",
      url: (window as any).VUE_APP_BASE_URL,
      submit_loading: false,

      async getApplyInfo() {
        const { data } = await queryApplyInfo(info.id);
        if (data.code == 200) {
          data.data.visiStartTime = data.data.visiStartTime.slice(0, 10);
          info.applyInfo = data.data;
          info.dataList = data.data.carsRecordList;
          info.view = data.data.approvalState == "5" ? false : true;
        }
      },

      async getApprovalInfo() {
        axios
          .get(
            info.url +
              "/sdApprovalInfo/selectCaApprovalInfoByProWorkHandelId/" +
              info.sdWorkHandleId,
            {
              headers: {
                Authorization: info.token,
              },
            }
          )
          .then((res) => {
            if (res.data.code == 200 && res.data.data) {
              info.remark = res.data.data.approvalOpinion;
              info.shdate = res.data.data.approvalTime.slice(0, 10);
              info.shr = res.data.data.approvalName;
              info.idea = res.data.data.idea;
            }
          });
      },
    });
    return { info, formRef };
  },
});
